
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"グループ 345","xmlns":"http://www.w3.org/2000/svg","width":"33.171","height":"50.158"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"パス 463","d":"M2.645 44.357V5.797a3.231 3.231 0 013.3-3.154h21.277a3.231 3.231 0 013.3 3.153V44.36a3.223 3.223 0 01-3.3 3.153H5.936a3.223 3.223 0 01-3.291-3.156z","fill":"none","stroke":"#12b6d4","stroke-linejoin":"round","stroke-width":"4.4"}}),_c('path',{attrs:{"data-name":"パス 464","d":"M12.719 14.589h-3.23a1.816 1.816 0 01-1.815-1.815v-3.4a1.816 1.816 0 011.815-1.815h3.23a1.816 1.816 0 011.815 1.815v3.4a1.816 1.816 0 01-1.815 1.815","fill":"#12b6d4"}}),_c('path',{attrs:{"data-name":"長方形 925","fill":"none","d":"M0 0h33.171v50.158H0z"}})])
          )
        }
      }
    